import {Button, Form, Input, Select, Spin} from 'antd';
import {jwtDecode} from 'jwt-decode';
import {PropTypes} from 'prop-types';
import {useEffect, useState} from 'react';
import {toast} from'react-hot-toast';
// import 'react-country-state-city/dist/react-country-state-city.css';
import {useSelector} from'react-redux';

import {RQGetUserDetails, RQUpdateUserProfileAPI} from '../../../reactQuery/apis';
import {selectAuth} from '../../../redux/selectors';

const AddressSection = ({setAddressComplete}) =>{
  const [form] = Form.useForm();

  const [setIsSubmitted] = useState(false);

  const [isFormOpen, setIsFormOpen] = useState(false);

  const auth = useSelector(selectAuth);

  const token = auth?.tokenData;

  const decodedToken = token ? jwtDecode(token) : null;

  const id = decodedToken?.userId;

  const {data: userData, isLoading, refetch} = RQGetUserDetails(id, token);

  const {mutate: updateUserProfile} = RQUpdateUserProfileAPI();
  const INDIA_STATES = [
    'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh',
    'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand', 'Karnataka',
    'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur', 'Meghalaya', 'Mizoram',
    'Nagaland', 'Odisha', 'Punjab', 'Rajasthan', 'Sikkim', 'Tamil Nadu',
    'Telangana', 'Tripura', 'Uttar Pradesh', 'Uttarakhand', 'West Bengal',
    'Andaman and Nicobar Islands', 'Chandigarh', 'Dadra and Nagar Haveli and Daman and Diu',
    'Delhi', 'Jammu and Kashmir', 'Ladakh', 'Lakshadweep', 'Puducherry',
  ];

  useEffect(() => {
    if (userData) {
      const values = {
        firstName: userData.firstName,
        lastName: userData.lastName,
        mobile: userData.mobile,
        address: userData.address,
        street: userData.street,
        apartment: userData.apartment,
        pinCode: userData.pinCode,
        city: userData.city,
        state: userData.state,
        district: userData.district,
      };
      form.setFieldsValue(values);
    }
  }, [userData]);

  const onFinish = values => {
    const formData = {
      firstName: values.firstName,
      lastName: values.lastName,
      email: userData?.email || '',
      mobile: values.mobile,
      address: values.address,
      street: values.street,
      apartment: values.apartment,
      pinCode: values.pinCode,
      city: values.city,
      district: values.district,
      state: values.state,  
    };

    updateUserProfile(
      {token, formData, id},
      {
        onSuccess: () => {
          toast.success('Profile updated successfully!');
          refetch();
          setIsFormOpen(false);
        },
        onError: error => {
          console.error(error);
          toast.error('Failed to update profile');
        },
      },
    );
    setIsSubmitted(true);
    setIsFormOpen(false);
  };
  useEffect(() => {
    if (userData) {
      const allFilled = [
        'firstName', 'lastName', 'mobile', 'address',
        'street', 'apartment', 'pinCode', 'city', 'district', 'state',
      ].every(field => userData[field]?.toString().trim() !== '');

      setAddressComplete?.(allFilled);
    }
  }, [userData]);

  const handleFormToggle = () => {
    setIsFormOpen(!isFormOpen);
  };

  if (isLoading) {
    return <div className={'flex justify-center items-center'}><Spin /></div>;
  }

  return (
    <div className={'w-full'}>
      <div className={'flex flex-col gap-1 p-2 border-primary-200 rounded-lg items-start'}>
        <h1 className={'text-base font-semibold'}>Deliver To:</h1>
        <div className={'lg:text-base'}>
          <div>{userData?.firstName} {userData?.lastName}</div>
          <div>{userData?.street}, {userData?.apartment},   {userData?.state},  {userData?.city},  {userData?.district} - {userData?.pinCode} 

          </div>
          <div>{userData?.mobile}</div>
        </div>
      </div>
      <div>
        <div className={'flex items-start flex-col gap-2'}>
          <Button
            color={'default'}
            type={'primary'}
            className={'p-1 !text-white bg-primary-900 hover:!bg-primary-800   my-3 text-md w-28'}
            onClick={handleFormToggle}
          >
            {isFormOpen ? 'Cancel' : 'Edit Address'}
          </Button>
        </div>

        {isFormOpen && (
          <Form layout={'vertical'}
            form={form}
            name={'address'}
            initialValues={{remember: true}}
            onFinish={onFinish}
            className={'lg:w-full'}
          >
            <div className={'grid lg:grid-cols-2 md:grid-cols-2 grid-cols-1 gap-4'}>
              <Form.Item label={'First Name'}
                name={'firstName'}
                rules={[
                  {required: true, message: 'Please enter your name'}, 
                  {
                    pattern:/^[A-Za-z]+$/, 
                    message: 'Only letters are allowed',
                  },
                  {whitespace: true, message: ''},
                ]}>
                <Input 
                  placeholder={'Name'}
                />
              </Form.Item>

              <Form.Item
                label={'Last Name'}
                name={'lastName'}
                rules={[
                  {required: true, message: 'Please enter your last name'},
                  {
                    pattern: /^[A-Za-z]+$/,
                    message: 'Only letters are allowed',
                  },
                  {whitespace: true, message: ''},
                ]}
              >
                <Input
                  placeholder={'Last Name'}
                />
              </Form.Item>

              <Form.Item
                label={'Contact No'}
                name={'mobile'}
                rules={[
                  {required: true, message: 'Please enter your contact number'},
                  {pattern: /^[0-9]{10}$/, message: 'Enter exactly 10 digits'},
                ]}
              >
                <Input
                  maxLength={10}
                  inputMode={'numeric'}
                  placeholder={'Contact No'}
                />
              </Form.Item>

              <Form.Item
                label={'Pincode'}
                name={'pinCode'}
                rules={[
                  {required: true, message: 'Please enter your pincode'},
                  {pattern: /^[1-9][0-9]{5}$/, message: 'Invalid pincode. Please enter 6 digits.'},
                ]}
              >
                <Input 
                  maxLength={6}
                  inputMode={'numeric'}  
                  placeholder={'Pincode'} 
                /> 
              </Form.Item>

              <Form.Item
                label={'Street'}
                name={'street'}
                rules={[{required: true, message: 'Please enter your street/area/colony'},
                  {whitespace: true, message: 'Street is required'},
                ]}
              >
                <Input 
                  placeholder={'Road name/area/colony'} 
                />
              </Form.Item>

              <Form.Item
                label={'Flat/ House no./ Building/ Apartment'}
                name={'apartment'}
                rules={[{required: true, message: 'Please enter your apartment/building'},
                  {whitespace: true, message: 'Apartment is required'},
                ]}
              >
                <Input placeholder={'Apartment'} />
              </Form.Item>

              <Form.Item
                label={'City'}
                name={'city'}
                rules={[
                  {
                    required: true,
                    message: 'City is required',
                  },
                  {
                    pattern: /^[A-Za-z]+(?: [A-Za-z]+)*$/,
                    message: 'Only letters allowed, no leading/trailing spaces',
                  },
                ]}
              >
                <Input placeholder={'City'} />
              </Form.Item>

              <Form.Item
                label={'District'}
                name={'district'}
                rules={[
                  {required: true, message: 'Please enter your district'},
                  {
                    pattern: /^[A-Za-z]+$/,
                    message: 'Only letters are allowed',
                  },
                ]}
              >
                <Input placeholder={'District'} />
              </Form.Item>

              <Form.Item
                label={'State'}
                name={'state'}
                rules={[{required: true, message: 'Please select your state'}]}
              >
                <Select
                  showSearch
                  placeholder={'Select State / UT'}
                  optionFilterProp={'children'}
                  filterOption={(input, option) =>
                    option?.children?.toLowerCase().includes(input.toLowerCase())
                  }
                >
                  {INDIA_STATES.map(st => (
                    <Select.Option key={st} value={st}>
                      {st}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>

              <Form.Item label={'Address'}
                name={'address'}
                rules={[
                  {required: true, message: 'Address is required'},
                  {whitespace: true, message: 'Address is required'},
                ]} 
              >
                <Input.TextArea  placeholder={'address'}
                />
              </Form.Item>
            </div>

            <Form.Item>
              <Button type={'primary'} htmlType={'submit'} className={'!bg-primary-900 text-sm text-white w-48'}>
                    Save
              </Button>
            </Form.Item>
          </Form>
        )}
      </div>
    </div>
  );
};

AddressSection.propTypes = {
  setAddressComplete: PropTypes.func,
};

export default AddressSection;
